export default "__VITE_ASSET__5tufXwAd__"